export default "__VITE_ASSET__d170ff5e__"